module.exports = __webpack_public_path__ + "static/media/goat.920f81a0.jpg";